import React from 'react';
import { prop } from 'ramda';
import { clsx } from '@core/js/utils/classNames.util';
import { WebContent } from '@core/js/components/system/WebContent';
import { useAppSelector } from '@core/js/store/hooks';
import { withComponent } from '@core/js/components/hocs/withComponent';

import { useShowingMode } from './../../hooks';
import { SHOWING_MODE } from './../../constants';

import style from './CookieMessage.scss';

export const CookieMessageBare: React.FC = () => {
    const { cookiesInformationWC } = useAppSelector(prop('cookiesConfiguration'));
    const showingMode = useShowingMode();
    const isCommonMode = showingMode === SHOWING_MODE.COMMON;

    return (
        <div className={style.container}>
            <div className={clsx([style.wc, isCommonMode && style.common])}>
                <WebContent id={cookiesInformationWC}/>
            </div>
        </div>
    );
};

export const CookieMessage = withComponent({
    tkPrefix: 'playtech.mobile.system.cookie-message-popup.'
})(CookieMessageBare);
